"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _Link = _interopRequireDefault(require("@sprinx/react-mui-components/Link"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _NewsListItem = _interopRequireDefault(require("../../../components/NewsListItem"));

var _PageSectionTitle = _interopRequireDefault(require("../../../components/PageSectionTitle"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3)
    },
    all: (0, _defineProperty2.default)({
      display: 'flex',
      justifyContent: 'center'
    }, theme.breakpoints.down('sm'), {
      paddingTop: theme.spacing(1)
    }),
    panel: {
      display: 'flex',
      flexWrap: 'wrap'
    },
    typo: (0, _defineProperty2.default)({
      color: theme.palette.common.black,
      fontWeight: 300
    }, theme.breakpoints.down('sm'), {
      textAlign: 'center'
    })
  };
}, {
  name: 'SxHomePageArticles'
});

function HomePageArticles(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      news = _ref.news,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "news"]);
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement(_PageSectionTitle.default, {
    classes: {
      typo: classes.typo
    }
  }, t('homePageArticles/title')), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.panel
  }, news.map(function (i, index) {
    return /*#__PURE__*/_react.default.createElement(_NewsListItem.default, {
      article: i,
      key: index.toString()
    });
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.all
  }, /*#__PURE__*/_react.default.createElement(_Link.default, {
    className: classes.typo,
    to: "/news"
  }, t('homePageArticles/button'))));
}

process.env.NODE_ENV !== "production" ? HomePageArticles.propTypes = {
  classes: _propTypes.default.shape({
    all: _propTypes.default.string,
    panel: _propTypes.default.string,
    root: _propTypes.default.string,
    typo: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  news: _propTypes.default.arrayOf(_propTypes.default.shape({
    comments: _propTypes.default.arrayOf(_propTypes.default.shape({})),
    href: _propTypes.default.string.isRequired,
    teaserImage: _propTypes.default.string,
    teaserText: _propTypes.default.string,
    title: _propTypes.default.string
  })).isRequired
} : void 0;
HomePageArticles.defaultProps = {
  classes: undefined,
  className: undefined
};
var _default = HomePageArticles;
exports.default = _default;